/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_ConvertInputs */

const cs_lead_convert = /** @type {(inputs: Lead_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převést na klienta`)
};

const en_lead_convert = /** @type {(inputs: Lead_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert to client`)
};

/**
* | output |
* | --- |
* | "Convert to client" |
*
* @param {Lead_ConvertInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_convert = /** @type {((inputs?: Lead_ConvertInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_ConvertInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_convert(inputs)
	return cs_lead_convert(inputs)
});